import { COUNTRY_OVERLAY_FLAG, ROE_CC, SET_CURRENCY } from '@/scripts/constants/cookies'
import { COUNTRY_LIST } from '../constants/countryList'

import { Cookies } from './cookies'
import { NoEcommerce } from './no-ecommerce'

export const roeCurrencies = {
  GR: 'EGR',
  LU: 'EUB',
  SI: 'ESL',
  SK: 'ESK',
  LT: 'EEU',
  MT: 'ECM',
  LV: 'EEU',
  EE: 'EEU',
  CY: 'ECM',
  FI: 'EFI',
}

export const setCurrencyPreference = (
  closeModal,
  href,
  roeCookie,
  roeCurrency,
  canRedirect = true
) => {
  if (!href.includes('/eu')) {
    Cookies.set(COUNTRY_OVERLAY_FLAG, true)
    localStorage.setItem(COUNTRY_OVERLAY_FLAG, true)
    removeSetCurrencyCookie()
    removeRoeCookie()
    if (!NoEcommerce.isStoreInNoEcommerceCountries(roeCookie)) {
      NoEcommerce.removeNoEcommerceCookie()
    }
    if (canRedirect) window.location.href = href
    closeModal
    return
  }

  if (!roeCookie || roeCookie === '') {
    removeSetCurrencyCookie()
    return
  }
  if (getCurrencyCookie() !== undefined) {
    if (getCurrencyCookie() === roeCurrency || getCurrencyCookie() === roeCurrencies[roeCookie])
      return
  }

  setRoeCurrencyCookieAndLocalStorage(roeCookie, roeCurrency)

  if (canRedirect) window.location.href = href
  closeModal
}

export const getRoeCookie = () => {
  const localStorageRoeCC = localStorage.getItem(ROE_CC)
  const cookieRoeCC = Cookies.get(ROE_CC)
  return cookieRoeCC || localStorageRoeCC
}

export const setRoeCookie = (roeCC) => {
  Cookies.set(ROE_CC, roeCC)
  localStorage.setItem(ROE_CC, roeCC)
}

export const removeRoeCookie = () => {
  Cookies.remove(ROE_CC)
  localStorage.removeItem(ROE_CC)
}

const areRoeCookieAndLocalStorageDifferent = () => {
  const localStorageRoeCC = localStorage.getItem(ROE_CC)
  const cookiesRoeCC = Cookies.get(ROE_CC)
  return localStorageRoeCC !== cookiesRoeCC
}

export const adjustRoeCookies = () => {
  if (areRoeCookieAndLocalStorageDifferent()) {
    setRoeCurrencyCookieAndLocalStorage(getRoeCookie(), null)
    setRoeCookie(getRoeCookie())
    Cookies.set(COUNTRY_OVERLAY_FLAG, false)
    localStorage.setItem(COUNTRY_OVERLAY_FLAG, false)
  }
}

export const setRoeCurrencyCookieAndLocalStorage = (roeCookie, roeCurrency) => {
  Cookies.set(COUNTRY_OVERLAY_FLAG, true)
  localStorage.setItem(COUNTRY_OVERLAY_FLAG, true)
  Cookies.set(SET_CURRENCY, roeCurrency || roeCurrencies[roeCookie])
  localStorage.setItem(SET_CURRENCY, roeCurrency || roeCurrencies[roeCookie])
}

export const getCurrencyCookie = () => {
  return Cookies.get(SET_CURRENCY) || localStorage.getItem(SET_CURRENCY)
}

export const removeSetCurrencyCookie = () => {
  Cookies.remove(SET_CURRENCY)
  localStorage.removeItem(SET_CURRENCY)
}

export const getSortedCountries = () => {
  const sortedCountryList = COUNTRY_LIST.sort((previousCountry, nextCountry) => {
    if (previousCountry.label < nextCountry.label) {
      return -1
    }
    if (previousCountry.label > nextCountry.label) {
      return 1
    }
    return 0
  })
  return sortedCountryList.filter((locale) => !locale.hidden)
}
